export default __webpack_public_path__ + "static/media/airlockz-wht-1.77e191e6.png";